import React from 'react'
import { compose } from 'recompose'

import Popper from '@material-ui/core/Popper'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

import withGeneralTranslations from '../hocs/withGeneralTranslations'

import HotspotWithLabel from '../components/HotspotWithLabel'
import SmallText from '../styleguide/SmallText'

const styles = theme => ({
  popper: {
    zIndex: 5
  },
  container: {
    width: 300,
    border: '1px solid #e2e3e4',
    padding: 20,
    marginTop: 8,
    backgroundColor: '#303c49',
    borderRadius: '4px',
    boxShadow: '0 10px 5px -5px rgba(0, 0, 0, 0.2)'
  },
  buttonRoot: {
    justifyContent: 'flex-start',
    color: '#e40045',
    padding: '10px 0',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#b10036'
    }
  },
  buttonLabel: {
    textTransform: 'none',
    fontFamily: 'MANEurope, Arial, sans-serif',
    fontWeight: 'bold',
    fontStretch: 'condensed'
  }
})

class HotspotWithText extends React.Component {
  state = {
    anchorEl: null
  }

  handleClick = event => {
    const { currentTarget } = event
    // needs to be set on click b/c with a ref the placement is wrong
    this.setState(state => ({
      anchorEl: currentTarget
    }))
    this.props.onHotspotClick(this.props.hotspot.slug)
  }

  render() {
    const { anchorEl } = this.state
    const { hotspot, active, classes, generalTranslations } = this.props
    const { slug, title, text, textAlign, posX, posY, theme } = hotspot

    const open = Boolean(anchorEl) && active
    const id = hotspot.slug

    return (
      <div>
        <HotspotWithLabel
          key={slug}
          active={open}
          posX={posX}
          posY={posY}
          textAlign={textAlign}
          label={title}
          onHotspotClick={this.handleClick}
          light={theme === 'light'}
        />
        <Popper
          id={id}
          className={classes.popper}
          open={open}
          anchorEl={anchorEl}
          placement="bottom"
          modifiers={{
            flip: { enabled: false }
            // preventOverflow: {
            //   enabled: false
            // }
            // hide: {
            //   enabled: false
            // }
          }}
        >
          <div className={classes.container}>
            <SmallText style={{ color: '#fafafa' }}>{text}</SmallText>
            <Button
              disableRipple
              onClick={this.handleClick}
              classes={{ root: classes.buttonRoot, label: classes.buttonLabel }}
            >
              {generalTranslations('close')}
            </Button>
          </div>
        </Popper>
      </div>
    )
  }
}

const StyledHotspotWithText = compose(
  withGeneralTranslations,
  withStyles(styles)
)(HotspotWithText)

class HotspotsWithText extends React.Component {
  state = {
    activeHotspot: ''
  }

  handleClick = hotspotSlug => {
    if (this.state.activeHotspot === hotspotSlug) {
      this.setState({ activeHotspot: '' })
    } else {
      this.setState({ activeHotspot: hotspotSlug })
    }
  }

  render() {
    const { activeHotspot } = this.state
    const { hotspots } = this.props

    return hotspots.map(hotspot => (
      <StyledHotspotWithText
        hotspot={hotspot}
        key={hotspot.slug}
        onHotspotClick={this.handleClick}
        active={hotspot.slug === activeHotspot}
      />
    ))
  }
}

export default HotspotsWithText



// WEBPACK FOOTER //
// ./src/components/HotspotsWithText.js